<template>
  <div class="bt-page">
    <img class="bt-logo" src="../assets/images/bt-logo.png" alt="">
    <div class="bt-name">得有店</div>
    <div class="btm-title" v-if="isShow">
      <img class="bt-icon" src="../assets/images/success.jpg" alt="">
      <div class="bt-title">创建店铺即代表您同意《得有店产品服务协议》</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isShow() {
      if(this.$route.path == '/login') {
        return false
      }else if(this.$route.path == '/page/register') {
        return false
      }else {
        return true
      }
    }
  }
}
</script>

<style lang="css" scoped>
.bt-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
  /* padding-bottom: 32px; */
  /* box-sizing: border-box; */
}
.bt-logo {
  width: 36px;
  height: 40.5px;
}
.bt-name {
  margin: 6px 0;
  font-size: 12px;
  color: #b9becc;
}
.btm-title {
  display: flex;
  align-items: center;
  margin-top: 50px;
}
.bt-icon {
  width: 10px;
  height: 10px;
  margin-right: 3px;
}
.bt-title {
  margin: 0;
  font-size: 10px;
  color: #b9becc;
}
</style>